module.exports = __webpack_public_path__ + "img/temp_icon.f4b2eea3.png";